import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { ArrowIcon } from "../icons";

const Button = ({ direction, onClick }) => (
  <button
    className={`m-slideshow__button m-slideshow__button--${direction}`}
    aria-label={direction}
    onClick={onClick}
  >
    <ArrowIcon
      className="m-slideshow__button-icon"
      styleProps={{
        transform: direction === "previous" ? "rotate(180deg)" : null,
      }}
    />
  </button>
);

Button.propTypes = {
  direction: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

const Navigation = ({
  count,
  active,
  onUpdate,
  buttonPosition,
  aspectRatio,
}) => {
  const handlePreviousClick = () => {
    const newSlide = active === 0 ? count - 1 : active - 1;
    updateActive(newSlide);
  };

  const handleNextClick = () => {
    const newSlide = active === count - 1 ? 0 : active + 1;
    updateActive(newSlide);
  };

  function updateActive(newActive) {
    if (active !== newActive) {
      onUpdate(newActive);
    }
  }

  return (
    <div
      className={classNames({
        "m-slideshow__nav-wrapper": true,
        "m-slideshow__nav-wrapper--fixed-height": true,
        "a-hidden": count <= 1,
      })}
    >
      <div
        className={`m-slideshow__nav m-slideshow__nav--${
          buttonPosition || "bottom-right-offset"
        } m-slideshow__nav--${aspectRatio || "5-4"}`}
      >
        <Button direction="previous" onClick={handlePreviousClick} />
        <div className="m-slideshow__position">{`${active + 1}/${count}`}</div>
        <Button direction="next" onClick={handleNextClick} />
      </div>
    </div>
  );
};

Navigation.displayName = "Slideshow.Navigation";

Navigation.propTypes = {
  count: PropTypes.number.isRequired,
  active: PropTypes.number.isRequired,
  onUpdate: PropTypes.func.isRequired,
  buttonPosition: PropTypes.string,
  aspectRatio: PropTypes.string,
};

export default Navigation;
